import React, { useState, useContext, useEffect, useImperativeHandle, useRef } from "react";

import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";
import toast from "react-hot-toast";

import api from "services/api";
import SortableList, { SortableItem } from "react-easy-sort";
import IconButton from "@mui/material/IconButton";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import CloseIcon from "@mui/icons-material/Close";
import ImageCardWrapper from "components/UpStyled/ImageCardWrapper";
import PostImageWrapper from "pages/de/posts/components/PostImageWrapper";

import { Badge } from "antd";

const RenderGridContentList = ({
  list,
  col = 1,
  gap = 0,
  sortable = false,
  handleDelete,
  handleClickContentStyle,
  post,
  setPost,
  readOnly = true,
}) => {
  const renderContentList = (list, col = 1, gap = 0) => {
    let result = [];
    const rowsCount = Math.ceil(list.length / col);
    for (let i = 0; i < list.length; i += col) {
      const row = [];

      for (let j = 0; j < col; j++) {
        const index = j + i;
        let item = list[index];
        if (item?.id) {
          let ratio = 0;
          if (item?.dimensions?.width && item?.dimensions?.height) {
            ratio = item.dimensions.width / item.dimensions.height;
          }

          let temp = (
            <SuiBox sx={{ flex: ratio == 0 ? 1 : ratio }}>
              {sortable ? (
                <SortableItem key={index}>
                  <div style={{ position: "relative", zIndex: 1400 }} className="hover-parent">
                    <ImageCardWrapper
                      data={item?.img}
                      isOriginalSize
                      draggable={false}
                      sx={{
                        cursor: "move",
                        zIndex: 1400,
                        borderRadius: 0,
                        width: "100%",

                        height: "auto",
                        objectFit: "contain",
                      }}
                    />

                    {handleDelete ? (
                      <SuiBox
                        aria-label="close"
                        onClick={() => handleDelete(index)}
                        sx={{
                          position: "absolute",
                          right: 4,
                          top: 4,
                          backgroundColor: (theme) => theme.palette.grey[500],
                          cursor: "pointer",
                          opacity: 0,
                          borderRadius: "50%",
                          height: 25,
                          width: 25,
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                        className="hover-children"
                      >
                        <CloseIcon color="white" />
                      </SuiBox>
                    ) : null}
                  </div>
                </SortableItem>
              ) : (
                <PostImageWrapper
                  item={item}
                  draggable={false}
                  post={post}
                  setPost={setPost}
                  isEdit={readOnly ? false : true}
                  sx={{
                    borderRadius: 0,
                    width: "100%",

                    height: "auto",
                    objectFit: "contain",
                    cursor: item?.resource_id && item?.type == "style" ? "pointer" : "default",
                  }}
                  readOnly={readOnly}
                  handleClick={
                    readOnly
                      ? () => {
                          if (
                            item?.resource_id &&
                            item?.type == "style" &&
                            handleClickContentStyle
                          ) {
                            handleClickContentStyle(item);
                          }
                        }
                      : null
                  }
                />
              )}
            </SuiBox>
          );

          row.push(temp);
        }
      }

      result.push(
        <SuiBox
          sx={{
            display: "flex",
            gap: gap + "px",
            mb: i == rowsCount ? 0 : gap + "px",
            width: "100%",
          }}
        >
          {row.map((x) => x)}
        </SuiBox>
      );
    }
    return result;
  };

  return (
    <SuiBox sx={{ display: "flex", flexWrap: "wrap", width: "100%", height: "auto" }}>
      {renderContentList(list, col, gap)}
    </SuiBox>
  );
};

export default RenderGridContentList;
